export const formatAuthors = (authors: string[]) => {
  if (authors.length === 1) {
    return authors[0];
  }
  if (authors.length > 1) {
    const initialAuthors = authors.slice(0, authors.length - 1);
    return `${initialAuthors.join(", ")} and ${authors[authors.length - 1]}`;
  }
};
